/**
 * Room, member, role, and playback-state types. FROZEN after WS-0.
 */
import { z } from 'zod';
export const RoleSchema = z.enum(['host', 'viewer']);
export const MemberSchema = z.object({
    userId: z.string(),
    displayName: z.string(),
    role: RoleSchema,
    joinedAt: z.number().int(),
});
export const PlaybackStateSchema = z.object({
    isPlaying: z.boolean(),
    position: z.number().nonnegative(),
    rate: z.number().positive(),
    updatedAt: z.number().int(),
});
export const RoomSummarySchema = z.object({
    id: z.string(),
    name: z.string(),
    mediaId: z.string(),
    memberCount: z.number().int().nonnegative(),
    createdAt: z.number().int(),
});
//# sourceMappingURL=rooms.js.map